<template>
    <div>
        <p class="border-b font-lg px-4 py-2">Målgruppe for tiltak</p>
        <div class="py-2 px-4 cursor-pointer">
            <label
                :for="`checkbox_${target.id}`"
                v-for="target in targets"
                :key="`checkbox_${target.id}`"
                class="block mb-2 pb-2 border-b cursor-pointer"
            >
                <input type="checkbox" :id="`checkbox_${target.id}`" :value="target.id" v-model="filters" @change="change()">
                <span class="ml-2">{{ target.name }} ({{ target.count }})</span>
            </label>
        </div>
        <div class="flex justify-end" :class="[filters.length > 0 ? 'pb-4 px-4' : 'hidden']">
            <button @click="reset()">
                Nullstill filter <font-awesome-icon class="ml-1" icon="times"/>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['allTargets', 'selectedFilters'],
    data() {
        return {
            targets: [],
            filters: []
        };
    },
    mounted() {
        this.targets = this.allTargets;
        this.filters = this.selectedFilters;
    },
    methods: {
        change() {
            this.$emit('handleCheckbox', this.filters);
        },
        reset() {
            this.filters = [];
            this.$emit('resetFilters');
        }
    }
};
</script>
